import { Link } from 'react-router-dom';
import './style.scss';

function ContentCircles () {
    return(
        <section className='content-circles' id='contentcircles'>
            <div className='container'>
                <h1 className='title'>
                    SZAKRENDELÉSEINK
                </h1>
                <div className='feature-row'>
                    <Link to={'/doctors/belgyógyászat'} className='feature best'>
                        <img src='/img/belgyogyasz.avif' alt='' className='image'/>
                        <h2 className='headline'>
                            Belgyógyászat
                        </h2>
                        <button className='button'>
                            Orvosaink
                        </button>
                        <p className='description'>
                        </p>
                    </Link>

                    <Link to={'/doctors/bőrgyógyászat'} className='feature'>
                        <img src='/img/borgyogyasz.jpg' alt='' className='image'/>
                        <h2 className='headline'>
                            Bőrgyógyászat
                        </h2>
                        <button className='button'>
                            Orvosaink
                        </button>
                        <p className='description'>
                        </p>
                    </Link>

                    <Link to={'/doctors/dietetika'} className='feature'>
                        <img src='/img/dietetic.avif' alt='' className='image'/>
                        <h2 className='headline'>
                           Dietetika
                        </h2>
                        <button className='button'>
                            Orvosaink
                        </button>
                        <p className='description'>
                        </p>
                    </Link>
                </div>
                <div className='feature-row'>
                    <Link to={'/doctors/endokrinológia'} className='feature'>
                        <img src='/img/endokrinologia.jpg' alt='' className='image'/>
                        <h2 className='headline'>
                           Endokrinológia
                        </h2>
                        <button className='button'>
                            Orvosaink
                        </button>
                        <p className='description'>
                        </p>
                    </Link>
                    <Link to={'/doctors/foglalkozás-egészségügy'} className='feature'>
                        <img src='/img/foglalkozas.jpg' alt='' className='image'/>
                        <h2 className='headline'>
                            Foglalkozás- egészségügyi vizsgálat
                        </h2>
                        <button className='button'>
                            Orvosaink
                        </button>
                        <p className='description'>
                        </p>
                    </Link>
                    <Link to={'/doctors/fül-orr-gégészet'} className='feature best'>
                        <img src='/img/fulorrgegesz.jpg' alt='' className='image'/>
                        <h2 className='headline'>
                           Fül-orr-gégészet
                        </h2>
                        <button className='button'>
                            Orvosaink
                        </button>
                        <p className='description'>
                        </p>
                    </Link>       
                </div>
                <div className='feature-row'>
                    <Link to={'/doctors/gyermekorvos'} className='feature best'>
                        <img src='/img/gyerekorvos.jpg' alt='' className='image'/>
                        <h2 className='headline'>
                            Gyermekorvos
                        </h2>
                        <button className='button'>
                            Orvosaink
                        </button>
                        <p className='description'>
                        </p>
                    </Link>
                    <Link to={'/doctors/kardiológia'} className='feature'>
                        <img src='/img/kardiologia.webp' alt='' className='image'/>
                        <h2 className='headline'>
                           Kardiológia
                        </h2>
                        <button className='button'>
                            Orvosaink
                        </button>
                        <p className='description'>
                        </p>
                    </Link>
                    <Link to={'/doctors/kézsebészet'} className='feature'>
                        <img src='/img/kezsebesz.jpg' alt='' className='image'/>
                        <h2 className='headline'>
                            Kézsebészet
                        </h2>
                        <button className='button'>
                            Orvosaink
                        </button>
                        <p className='description'>
                        </p>
                    </Link>                
                </div>
                <div className='feature-row'>
                    <Link to={'/doctors/lézersebészet'} className='feature'>
                        <img src='/img/lasersurgery.jpg' alt='' className='image'/>
                        <h2 className='headline'>
                            Lézersebészet
                        </h2>
                        <button className='button'>
                            Orvosaink
                        </button>
                        <p className='description'>
                        </p>
                    </Link>
                    <Link to={'/doctors/neurológia'} className='feature best'>
                        <img src='/img/neurologia.jpg' alt='' className='image'/>
                        <h2 className='headline'>
                            Neurológia
                        </h2>
                        <button className='button'>
                            Orvosaink
                        </button>
                        <p className='description'>
                        </p>
                    </Link>
                    <Link to={'/doctors/nőgyógyászat'} className='feature'>
                        <img src='/img/nogyogyasz.jpg' alt='' className='image'/>
                        <h2 className='headline'>
                            Nőgyógyászat
                        </h2>
                        <button className='button'>
                            Orvosaink
                        </button>
                        <p className='description'>
                        </p>
                    </Link>
                </div>
                <div className='feature-row'>
                    <Link to={'/doctors/ortopédia'} className='feature ortopedia-feature'>
                        <img src='/img/ortopedia.jpg' alt='' className='image'/>
                        <h2 className='headline'>
                            Ortopédia
                        </h2>
                        <button className='button'>
                            Orvosaink
                        </button>
                        <p className='description'>                 
                        </p>
                    </Link>
                    <Link to={'/doctors/proktológia'} className='feature'>
                        <img src='/img/proctology.jpg' alt='' className='image'/>
                        <h2 className='headline'>
                            Proktológia
                        </h2>
                        <button className='button'>
                            Bejelentkezés
                        </button>
                        <p className='description'>
                        </p>
                    </Link> 
                    <Link to={'/doctors/plasztikai sebészet'} className='feature'>
                        <img src='/img/plastic.jpg' alt='' className='image'/>
                        <h2 className='headline'>
                            Plasztikai sebészet
                        </h2>
                        <button className='button'>
                            Bejelentkezés
                        </button>
                        <p className='description'>
                        </p>
                    </Link>
                                       
                </div>
                <div className='feature-row'>
                    <Link to={'/doctor/synlab-vervetel'} className='feature'>
                        <img src='/img/vervetel.png' alt='' className='image'/>
                        <h2 className='headline'>
                            SYNLAB-Partner Laborvizsgálat
                        </h2>
                        <button className='button'>
                            Bejelentkezés
                        </button>
                        <p className='description'>
                        </p>
                    </Link>
                    <Link to={'/doctors/traumatologia'} className='feature'>
                        <img src='/img/trauma.jpg' alt='' className='image'/>
                        <h2 className='headline'>
                            Traumatológia
                        </h2>
                        <button className='button'>
                            Orvosaink
                        </button>
                        <p className='description'>                 
                        </p>
                    </Link>   
                    <Link to={'/doctors/ultrahang'} className='feature'>
                        <img src='/img/ultrahang.jpg' alt='' className='image'/>
                        <h2 className='headline'>
                            Ultrahang
                        </h2>
                        <button className='button'>
                            Orvosaink
                        </button>
                        <p className='description'>                 
                        </p>
                    </Link>          
                       
                </div>
                <div className='feature-row'>
                    <Link to={'/doctors/urológia'} className='feature'>
                        <img src='/img/urologia.png' alt='' className='image'/>
                        <h2 className='headline'>
                           Urológia
                        </h2>
                        <button className='button'>
                            Orvosaink
                        </button>
                        <p className='description'>
                        </p>
                    </Link>
                </div>               
            </div>
        </section>
    )
}

export default ContentCircles;
